module.exports = __webpack_public_path__ + "static/img/flag-en.feb00478.png";